import type {
  ApprovalCreateFieldOptions,
  ApprovalOptionCreationValue,
} from '@cims-online/shared'
import { Select } from 'antd'
import type { CreationFieldProps } from '..'
import CreationFormItem from './CreationFormItem'

type ApprovalSelectProps = {
  field: ApprovalCreateFieldOptions
  id?: string
  onBlur: () => void
  onChange?: (value: ApprovalOptionCreationValue[]) => void
  value?: ApprovalOptionCreationValue[]
}

/** Adapts selected option IDs to pending approval values. */
function ApprovalSelect({
  field,
  id,
  onBlur,
  onChange,
  value = [],
}: ApprovalSelectProps) {
  const selectedOptionIds = value.map(({ optionId }) => optionId)

  return (
    <Select
      allowClear={field.readOnly === null}
      disabled={field.readOnly !== null}
      id={id}
      mode={field.single ? undefined : 'multiple'}
      onBlur={onBlur}
      onChange={(selection: string | string[] | undefined) => {
        const optionIds =
          typeof selection === 'string' ? [selection] : selection ?? []
        onChange?.(optionIds.map((optionId) => ({ optionId, state: null })))
      }}
      options={field.options.map(({ id, label, tooltip }) => ({
        label,
        title: tooltip ?? undefined,
        value: id,
      }))}
      style={{ width: '100%' }}
      value={field.single ? selectedOptionIds[0] : selectedOptionIds}
    />
  )
}

type ApprovalCreationFieldProps = Omit<CreationFieldProps, 'field'> & {
  field: ApprovalCreateFieldOptions
}

/** Renders an approval creation input with its resolved option behavior. */
function ApprovalCreationField({
  error,
  field,
  onBlur,
}: ApprovalCreationFieldProps) {
  return (
    <CreationFormItem
      control={<ApprovalSelect field={field} onBlur={onBlur} />}
      error={error}
      field={field}
    />
  )
}

export default ApprovalCreationField
